(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    // Shopinfo (TASK-159): o card Ordenar do celular delega ao select da gaveta,
  // cujo form conhece os filtros ativos. Delegacao no document: o re-render troca o bloco.
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.hasAttribute('data-shopinfo-sort')) return;
    const drawerSelect = document.querySelector('#filters-drawer select[name="sort_by"]');
    if (!(drawerSelect instanceof HTMLSelectElement)) return;
    drawerSelect.value = select.value;
    if (drawerSelect.value !== select.value) return;
    const status = select.parentElement?.querySelector('[data-shopinfo-sort-status]');
    if (status) status.textContent = select.selectedOptions[0]?.textContent?.trim() ?? '';
    drawerSelect.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shopinfo-collection-description"] && !Shopify.designMode) return;
  try {
    (function () {
    function setOpen(root, open) {
      var btn = root.querySelector('.shopinfo-coll-desc__toggle');
      if (!btn) return;
      root.classList.toggle('is-expanded', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.shopinfo-coll-desc__toggle');
      if (!btn) return;
      setOpen(btn.closest('.shopinfo-coll-desc'), btn.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('focusin', function (e) {
      var root = e.target.closest && e.target.closest('.shopinfo-coll-desc--clamp:not(.is-expanded)');
      if (root && !e.target.classList.contains('shopinfo-coll-desc__toggle')) setOpen(root, true);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shopinfo-urgency"] && !Shopify.designMode) return;
  try {
    (function () {
    var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq && mq.matches) return;

    function start() {
      document.querySelectorAll('[data-shopinfo-urgency]').forEach(function (root) {
        var el = root.querySelector('.shopinfo-urgency__n');
        if (!el) return;
        var min = parseInt(root.getAttribute('data-min'), 10);
        var max = parseInt(root.getAttribute('data-max'), 10);
        var cur = parseInt(el.textContent, 10);
        if (isNaN(min) || isNaN(max) || isNaN(cur) || max <= min) return;

        (function tick() {
          setTimeout(function () {
            if (!document.hidden) {
              var next = cur + (Math.random() < 0.5 ? -1 : 1);
              if (next >= min && next <= max) {
                cur = next;
                el.textContent = cur;
              }
            }
            tick();
          }, 30000 + Math.random() * 30000);
        })();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
